import React from 'react';
import EventContentHeader from '../../../elements/headers/EventContentHeader';
import styles from './EventDirectoryHeader.module.scss';
import DirectoryItemLogo from './DirectoryItemLogo/DirectoryItemLogo';
import DirectoryItemDetailsImage from './DirectoryItemDetailsImage/DirectoryItemDetailsImage';

function EventDirectoryHeader(props) {
    const { item, parent } = props;

    // Name - only if it has a parent, otherwise the name repeats on the topbar
    let itemName = null;
    if (parent?.name) {
        itemName = <EventContentHeader className={styles.header}>{item.name}</EventContentHeader>;
    }

    // Location
    let itemLocation = null;
    if (item.location) {
        itemLocation = (
            <div className="content">
                <div className={styles.location}>{item.location}</div>
            </div>
        );
    }

    return (
        <>
            <DirectoryItemDetailsImage item={item} />
            <div className={styles.layout}>
                <div>
                    {itemName}
                    {itemLocation}
                </div>
                {!item.detailsImageUrl ? <DirectoryItemLogo className={styles.logo} item={item} /> : null}
            </div>
        </>
    );
}

export default EventDirectoryHeader;
